<template>
  <span>
    <input class="input-file" type="file" @change="exportData"
           accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
    <a class="xo-xlxs-btn" @click="btnClick">{{title}}</a>
  </span>
</template>

<script>
  import XLSX from 'xlsx'
  export default {
    name: "inputExcel",
    props: {
      title: {
        type: String,
        default: "选择excel文件"
      }
    },
    methods: {
      btnClick() {
        document.querySelector(".input-file").click();
      },
      exportData(event) {
        if(!event.currentTarget.files.length) {
          return;
        }
        const that = this;
        // 拿取文件对象
        var f = event.currentTarget.files[0];
        // 用FileReader来读取
        var reader = new FileReader();
        // 重写FileReader上的readAsBinaryString方法
        FileReader.prototype.readAsBinaryString = function(f) {
          var binary = "";
          var wb; // 读取完成的数据
          var outdata; // 你需要的数据
          var reader = new FileReader();
          reader.onload = function(e) {
            // 读取成Uint8Array，再转换为Unicode编码（Unicode占两个字节）
            var bytes = new Uint8Array(reader.result);
            var length = bytes.byteLength;
            for (var i = 0; i < length; i++) {
              binary += String.fromCharCode(bytes[i]);
            }
            // 接下来就是xlsx了，具体可看api
            wb = XLSX.read(binary, {
              type: "binary"
            });
            outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
            // 自定义方法向父组件传递数据
            that.$emit("getResult", outdata);
          };
          reader.readAsArrayBuffer(f);
        };
        reader.readAsBinaryString(f);
      }
    }
  }
</script>

<style scoped>
  .input-file {
    display: none;
  }
  .xo-xlxs-btn {
    display: inline-block;
    height: 26px;
    line-height: 26px;
    padding: 0 5px;
    margin-right: 3px;
    background-color: #ff3633;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/xlsx-reader/index.vue